 import { Alpine } from '../core/alpine-core.js';
 
 Alpine.data('noAuthPage', () => ({
    goBack() {
      const from = sessionStorage.getItem('NOAUTH_FROM');
      // Prefer real back if it makes sense
      if (document.referrer || (history.length > 1)) {
        // If "from" exists and isn't this page, try navigate there
        if (from && !location.pathname.endsWith('/no-auth')) {
          // Use Pinecone to avoid full reload inside admin
          const { PineconeRouter: Router } = window;
          if (Router) return Router.navigate(from, { replace: true });
        }
        history.back();
        return;
      }
      // Fallback
      const { PineconeRouter: Router } = window;
      if (Router) Router.navigate('/admin/dashboard', { replace: true });
      else location.href = '/admin/dashboard';
    }
  }));
